/* Gualtara — scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.gl-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('gl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gl-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparar() {
    document.querySelectorAll('[data-gl-comparar]').forEach(function (marco) {
      if (marco.dataset.listo) return;
      marco.dataset.listo = '1';
      var arrastrando = false;
      function mover(clientX) {
        var r = marco.getBoundingClientRect();
        var p = Math.min(Math.max((clientX - r.left) / r.width, 0), 1) * 100;
        marco.style.setProperty('--gl-pos', p + '%');
      }
      marco.addEventListener('pointerdown', function (e) { arrastrando = true; mover(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (arrastrando) mover(e.clientX); });
      window.addEventListener('pointerup', function () { arrastrando = false; });
      marco.addEventListener('keydown', function (e) {
        var actual = parseFloat(getComputedStyle(marco).getPropertyValue('--gl-pos')) || 50;
        if (e.key === 'ArrowLeft') marco.style.setProperty('--gl-pos', Math.max(actual - 5, 0) + '%');
        if (e.key === 'ArrowRight') marco.style.setProperty('--gl-pos', Math.min(actual + 5, 100) + '%');
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-gl-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('.gl-galeria__principal img');
      if (!principal) return;
      gal.querySelectorAll('[data-gl-foto]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = btn.dataset.glFoto;
            principal.srcset = '';
            principal.alt = btn.dataset.glAlt || '';
            principal.style.opacity = 1;
          }, 180);
          gal.querySelectorAll('[data-gl-foto]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function formatearDinero(centavos, formato) {
    var valor = (centavos / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (formato || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, valor);
  }

  function initCompra() {
    document.querySelectorAll('[data-gl-compra]').forEach(function (caja) {
      var form = caja.querySelector('form');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var boton = form.querySelector('[type="submit"]');
      var textoBoton = boton ? boton.innerHTML : '';
      var cantidad = caja.querySelector('.gl-cantidad input');

      caja.querySelectorAll('.gl-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cantidad.value, 10) || 1;
          cantidad.value = Math.max(1, v + (b.dataset.paso === 'mas' ? 1 : -1));
        });
      });

      var cantidadOferta = caja.querySelector('[data-gl-cantidad-oferta]');
      caja.querySelectorAll('[data-gl-ofertas] input[type="radio"]').forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked && cantidadOferta) cantidadOferta.value = r.value; });
      });

      var datos = caja.querySelector('script[data-gl-variantes]');
      var selects = caja.querySelectorAll('[data-gl-opcion]');
      if (datos && selects.length) {
        var variantes = JSON.parse(datos.textContent);
        var formato = caja.dataset.formato;
        selects.forEach(function (sel) {
          sel.addEventListener('change', function () {
            var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
            var precio = caja.querySelector('.gl-precio__actual');
            var antes = caja.querySelector('.gl-precio__antes');
            if (!v) { boton.disabled = true; boton.innerHTML = caja.dataset.noDisponible; return; }
            idInput.value = v.id;
            if (precio) precio.textContent = formatearDinero(v.price, formato);
            if (antes) {
              antes.textContent = v.compare_at_price > v.price ? formatearDinero(v.compare_at_price, formato) : '';
            }
            boton.disabled = !v.available;
            boton.innerHTML = v.available ? textoBoton : caja.dataset.agotado;
          });
        });
      }

      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
        e.preventDefault();
        boton.disabled = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            boton.disabled = false;
            if (res.status) { form.submit(); return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { boton.disabled = false; form.submit(); });
      });
    });
  }

  function init() { initReveal(); initComparar(); initGaleria(); initCompra(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
